






































































import { Component, Vue, Prop } from "vue-property-decorator";
import * as _ from "lodash";
import Gailan from "./shijuangailan.vue";
import { GetExamDetail$ } from "@/request/jxgl";
import {
  GetStudentInfo$,
  GetExamAnswerDetail$,
} from "@/request/shezhenjiaoxue";
import Danxuan from "./danxuan.vue";
import Duoxuan from "./duoxuan.vue";
@Component({
  components: {
    Gailan,
    Danxuan,
    Duoxuan,
  },
})
export default class SzksResult extends Vue {
  private exam: any = {};
  private userId: any = "";
  private student: any = {};
  private filters: any = {
    current_page: 1,
    total_count: 0,
    total_page: 0,
    page_count: 5,
  };
  private result: any = {
    questions: [],
  };
  private get currentQuestions() {
    const startIndex =
      (this.filters.current_page - 1) * this.filters.page_count;
    const tempArr = _.cloneDeep(this.result.questions);
    return tempArr.splice(startIndex, this.filters.page_count);
  }
  /**
   * @description 获取考试详情
   */
  private fetchExamDetail() {
    GetExamDetail$(this, {
      params: { exam_id: this.result.exam_id },
    }).then((data: any) => {
      this.$set(this, "exam", _.cloneDeep(data));
    });
  }
  /**
   * @description 获得试卷结果详情
   */
  private fetchResultDetail() {
    const params: any = {
      params: {
        exam_id: this.result.exam_id,
      },
    };
    if (this.userId) {
      params["params"]["user_id"] = this.userId;
    }
    GetExamAnswerDetail$(this, params).then((data: any) => {
      this.$set(this, "result", _.cloneDeep(data));
      this.filters.total_count = this.result.questions.length;
      this.filters.total_page = Math.ceil(
        this.result.questions.length / this.filters.page_count
      );
    });
  }

  /**
   * @description 获得学生信息
   */
  private fetchStudentDetail() {
    const params: any = {
      params: {
        exam_id: this.result.exam_id,
      },
    };
    if (this.userId) {
      params["params"]["user_id"] = this.userId;
    }
    GetStudentInfo$(this, params).then((data: any) => {
      this.$set(this, "student", data);
    });
  }
  /**
   * @description 上一页
   */
  private prev() {
    this.filters.current_page--;
  }
  /**
   * @description 下一页
   */
  private next() {
    this.filters.current_page++;
  }
  /**
   * @description 跳转到某题目所在的页面
   */
  private jumpTo(index) {
    const target = Math.ceil((index + 1) / this.filters.page_count);
    if (target === this.filters.current_page) {
      return;
    }
    this.filters.current_page = target;
  }
  /**
   * @description 初始化
   */
  private mounted() {
    if (this.$route.query.id) {
      this.result.exam_id = this.$route.query.id;
      if (this.$route.query.user_id) {
        this.userId = this.$route.query.user_id;
      }
      this.fetchExamDetail();
      this.fetchResultDetail();
      this.fetchStudentDetail();
    } else {
      this.$message.error("参数有误，请重新预览");
    }
  }
}
